export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Көрсетілген:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["барлығы"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бетте"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Көрсету"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нәтижелер"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ішінен"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сауда"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Саудалар"])}
}